import styled, { css } from 'styled-components';
import { InputBase } from '@mui/material';
import { Palette } from 'config';

export const ErrorWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  img,
  svg {
    height: 16px;
    min-width: 16px;
    max-width: 16px;
  }
`;

export const ErrorText = styled.span`
  color: ${() => Palette.Red._700};
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-left: 8px;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 4px;

  svg {
    fill: ${Palette.PrimaryGray._400};
  }
  :hover {
    background: ${Palette.PrimaryGray._100};
    svg {
      fill: ${Palette.PrimaryGray._500};
    }
  }
  :active {
    background: ${Palette.Primary._000};
    svg {
      fill: ${Palette.Primary._500};
    }
  }
  ${({ isActive }) =>
    isActive &&
    css`
      svg {
        fill: ${() => Palette.Primary._500}!important;
      }
    `}
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`;

export const DisabledIconWrapper = styled.div``;

export const Container = styled.div`
  position: relative;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  ${IconWrapper} {
    position: absolute;
    right: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ multiline }) =>
      multiline
        ? css`
            top: 14px;
          `
        : css`
            top: 50%;
            transform: translateY(-50%);
          `};
  }
`;

export const ArrowWrapper = styled.div`
  position: absolute;
  right: 14px;
  top: 9px;
  cursor: pointer;
  ${({ arrowIconIsActive }) => {
    if (arrowIconIsActive) {
      return css`
        svg {
          fill: ${() => Palette.Primary._500};
          transform: rotate(180deg);
        }
      `;
    } else {
      return css`
        svg {
          fill: ${() => Palette.PrimaryGray._400};
          cursor: pointer;
          &:active {
            fill: ${() => Palette.Primary._300};
          }
        }
      `;
    }
  }}
`;

export const IconsContainer = styled.div`
  ${ArrowWrapper} {
  }
  ${IconWrapper} {
    position: absolute;
    right: ${({ isDropdown }) => (isDropdown ? '32px' : '10px')};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledInput = styled(InputBase)`
  color: ${() => Palette.PrimaryGray._900};
  max-height: ${({ multiline }) => !multiline && '40px'};
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  padding: 10px 8px;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  border: 0;
  outline: none;
  border: 1px solid ${() => Palette.PrimaryGray._200};
  padding-right: ${({ righticon }) => righticon && '35px'};
  background: ${() => Palette.PrimaryGray._000};
  transition: 0.2s ease-in-out;
  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  input {
    padding: 0;
  }
  textarea {
    margin: ${({ multiline }) => (multiline ? '0 2px 0 8px' : '0 16px')};
    padding-right: 29px;
    ::-webkit-scrollbar {
      width: 6px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: ${() => Palette.PrimaryGray._300};
    }
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  ${({ error }) =>
    error &&
    css`
      background: ${() => Palette.PrimaryGray._000};
      border: 1px solid ${() => Palette.Red._300};
    `}
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  border-radius: 4px;
  position: relative;
  width: ${({ inputWidth }) => (inputWidth ? `${inputWidth}px` : '100%')};
  ${DisabledIconWrapper} {
    position: absolute;
    right: 19.5px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.5;
  }
  & .Mui-focused {
    background: #ffffff;
    border: 1px solid ${() => Palette.Primary._300};
    box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16), inset 0px 2px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    /* z-index: 50; */
  }
  & div.Mui-disabled {
    opacity: 0.5;
    border: 1px solid ${() => Palette.PrimaryGray._300};
    &:hover {
      border: 1px solid ${() => Palette.PrimaryGray._300};
    }
  }
  & input.Mui-disabled {
    color: ${() => Palette.PrimaryGray._900};
    padding-right: 24px;
  }
  & > :first-child {
    ${({ isActive }) =>
      isActive
        ? css`
            border: 1px solid ${() => Palette.Primary._300};
            border-radius: 4px;
          `
        : ''}
  }
  /* & .MuiInputBase-root {
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
  } */

  ${StyledInput} {
    ${({ withLabel }) =>
      withLabel &&
      css`
        border-radius: 0 4px 4px 0;
      `}
  }
`;

export const TopLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${() => Palette.PrimaryGray._700};
  margin: 0 0 8px 0;
`;
